import React, { Component } from 'react';
import * as api from '../../api/api';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Grid, GridCell } from 'rmwc/Grid';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import {TextField} from 'rmwc/TextField';
import { Select } from 'rmwc/Select';
import StatusMessage from '../../util/StatusMessage'

class AdminAddCoupon extends Component{

	constructor(props){
    super(props);
    this.state={
      data: {
      	couponName: '',
      	couponCount: '',
      	tqTestTrack: [],
      	tqTestTrackId: '',
      },
      formErrors: {
        'couponNameError': '',
        'couponCountError': '',
        'testTrackError': '',
      },
      errorMsg: '',
      buttonDisable: false,
    }
  }

	componentDidMount() {
    const data = Object.assign({}, this.state.data);
    let url = 'admin/fetch/tq/test/tracks'

    return api.getResponse(this.props.user.accessToken, url)
      .then((result) => {
        data.tqTestTrack = result
          this.setState({data: data})
      })
  }

  validateForm(){

    let error = true
    let errorObj = Object.assign({}, this.state.formErrors)
    let data = Object.assign({}, this.state.data)

    errorObj.couponNameError = ''
    errorObj.couponCountError = ''
    errorObj.testTrackError =''


    if(!(data.couponName) || data.couponName === ''){
      errorObj.couponNameError ='Coupon name is mandatory'
      error = false
    }

    if(!(data.couponCount) || data.couponCount === ''){
      errorObj.couponCountError ='Coupon count is mandatory'
      error = false
    }

    if(data.couponCount <= 0){
      errorObj.couponCountError ='Coupon count must be greater than 0'
      error = false
    }

    if(!(data.tqTestTrackId) || data.tqTestTrackId === ''){
      errorObj.testTrackError ='Please select the test track'
      error = false
    }

    this.setState({
      formErrors:errorObj,
      errorMsg:'',
      buttonDisable: false
    })
    return error
  }

  handleAddNewCoupon = (event) => {
  	event.preventDefault()
    let data = Object.assign({}, this.state.data)
    this.setState({buttonDisable: true})
    if(this.validateForm()) {
      let apiInput = {
      	'name': data.couponName,
      	'certification_type_id': 4,
      	'tq_test_track_id': data.tqTestTrackId,
      	'total_count': parseInt(data.couponCount)
      }

      
    api.adminInsertingCoupons(this.props.user.accessToken, apiInput)
      .then((result) => {     
        if(result.errors) {
          this.setState({ errorMsg: result.errors,buttonDisable: false })
        }
        else{
          this.setState({errorMsg: result.message,buttonDisable: true})
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack,buttonDisable: false })
      })
    }
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  };

  handleTestTrackChange = (event) =>{
    let data = Object.assign({}, this.state.data)
    if(event.target.value){
      let selectedOption = event.target.value
      data.tqTestTrackId = selectedOption
      var optionElement = event.target.childNodes[event.target.selectedIndex]
    }
    else{
      data.tqTestTrackId = ''
    }
    this.setState({data: data})
  }

  goBack = () => {
    this.props.history.push('/portal/app/admin/coupons')
  }

	render() {
		return (
			<form onSubmit={(e) => this.handleAddNewCoupon(e)} style={{width: '100%'}}>
        <Card style={{padding: '25px'}}>
          <Grid>
            <GridCell span="10"><Typography use="headline5">Add Coupons</Typography></GridCell>
            <GridCell span="2"><Button raised onClick={this.goBack}>Go Back</Button></GridCell>
          </Grid>
          <Grid className="opportunity-list-item">

            <GridCell span="6">
              <TextField fullwidth className='text_input' label="Coupon Name" autoComplete="off"  name="couponName" onChange={this.onInputChange} value={this.state.data.couponName}/>
            </GridCell>
            <GridCell span="6"/>
            <GridCell span="6">
              <div className="full-width">
                <div className="mdc-select" role="listbox">
                  <select 
                    name="testcenter"
                    onChange={this.handleTestTrackChange}
                    value={this.state.data.tqTestTrackId}
                    className="mdc-select__native-control two-col-input"
                  >
                    <option value="" selected="">--Select Test Track--</option>
                    {this.state.data.tqTestTrack.map(testTrack => (
                      <option key={testTrack.id} value={testTrack.id} data-name={testTrack.name} track-amount={testTrack.amount}>
                        {testTrack.name} 
                      </option>
                    ))}
                  </select>
                  <label className="mdc-floating-label mdc-floating-label--float-above">Test Track</label>
                  <div className="mdc-line-ripple"></div>
                </div>
              </div>
            </GridCell>
            <GridCell span="6"></GridCell>
            <GridCell span="6">
              <TextField fullwidth className='text_input' label="Coupon Count" type="number" autoComplete="off"  name="couponCount" onChange={this.onInputChange} value={this.state.data.couponCount}/>
            </GridCell>
            <GridCell span="6"/>
            <GridCell span="6">
              <Button raised disabled={this.state.buttonDisable}>Add</Button>
            </GridCell> 
          </Grid>
          <StatusMessage error_msg = {this.state.errorMsg}/>
          <StatusMessage error_msg = {this.state.formErrors.couponNameError}/>
          <StatusMessage error_msg = {this.state.formErrors.testTrackError}/>
          <StatusMessage error_msg = {this.state.formErrors.couponCountError}/>
        </Card>
      </form>
		)
	}
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminAddCoupon);


// WEBPACK FOOTER //
// ./src/views/admin/AdminAddCoupon.jsx